<template>
  <div class="p-modal-main">
    <div class="p-modal-main__base"></div>
    <div class="p-modal-main__scrollable">
      <div class="p-modal-main__scrollable__padding">
        <div v-if="$slots.body" class="p-modal-main__content" @click.stop>
          <p v-if="$slots.head" class="p-modal-main__head">
            <slot name="head"></slot>
          </p>
          <div class="p-modal-main__body">
            <slot name="body"></slot>
          </div>
        </div>
        <div v-if="$slots.fullBody" class="p-modal-main__full_body" @click.stop>
          <slot name="fullBody"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({})
export default class ModalMain extends Vue {}
</script>

<style lang="scss" scoped>
// 幅1111px未満ではヘッダーがz-index:10000で貼り付くため、それより上に置く
$p-modal-main-index: 11000;
.p-modal-main {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  z-index: $p-modal-main-index;

  &__scrollable {
    position: relative;
    height: 100%;
    z-index: $p-modal-main-index + 200;
    overflow-y: scroll;
    backface-visibility: hidden;

    &__padding {
      min-height: 100%;
      padding: rem(40);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  &__head {
    font-size: rem(14);
    font-weight: bold;
    line-height: (19/14);
    text-align: center;
  }

  &__body {
    margin-top: rem(16);

    &:first-child {
      margin-top: 0;
    }
  }

  &__content {
    width: rem(288);
    padding: rem(40) rem(24);
    background: $common-white;
    border-radius: rem(2);
  }
  &__base {
    content: "";
    position: fixed;
    z-index: $p-modal-main-index + 100;
    left: 0;
    right: 0;
    top: 0;
    bottom: rem(-100);
    z-index: 1000;
    background: $common-black;
    opacity: 0.7;
    display: block;
  }
}
</style>
